module.exports = __webpack_public_path__ + "static/img/voice-0.4c197665.png";